import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { SemCreativeCardComponent } from '../sem-creative-card/sem-creative-card.component';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-sem-creative-card-v1',
	templateUrl: './sem-creative-card-v1.component.html',
	styleUrls: ['./sem-creative-card-v1.component.css']
})
export class SemCreativeCardV1Component extends SemCreativeCardComponent implements OnInit, WidgetCore, OnDestroy {
	public creatives: CreativePerformance[] = [];
	public displayIndex: any;
	public count: any;
	public totalCreatives = 0;
	public semCreativeCard = {};
	public hasData: boolean;
	public reloadSubscription;
	public widgetDataSubscription;
	range: string;
	semGoLiveDate: string;
	isGoliveNotStarted: boolean;
	isCutoffDate: boolean;
	@Input() defaultsort: string;

	constructor(protected analyticsService: AnalyticsService) {
		super(analyticsService);
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit() {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		if (this.defaultsort === 'true') {
			this.defaultsort = JSON.parse(this.defaultsort);
		} else {
			this.defaultsort = null;
		}
		this.requestData();
	}

	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData() {
		this.hasData = true;
		this.showLoad = true;
		this.count = 1;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success) {
				this.hasData = true;
				this.processResponseData(response.data);
				this.analyticsService.checkDateRange();
				this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
				this.isCutoffDate = this.analyticsService.isCutoffDate;
			} else {
				this.hasData = false;
				this.creatives = [];
				this.totalCreatives = 0;
			}
		});
	}

	processResponseData(responseData) {
		if (responseData.length > 0) {
			this.hasData = true;
			this.creatives = this.mapResponseDataToInterface(responseData);
			if (!this.defaultsort) {
				this.displayIndex = this.creatives.length - 1;
			} else {
				this.displayIndex = 0;
			}
			this.totalCreatives = this.creatives.length;
			this.setSlide();
			this.setDisplayIndexContent(this.displayIndex);
		} else {
			this.hasData = false;
			this.totalCreatives = 0;
			this.semCreativeCard = {};
		}
	}

	setSlide() {
		this.nextArrow();
		this.prevArrow();
	}

	setDisplayIndexContent(displayIndex) {
		if (this.creatives.length > 0) {
			this.semCreativeCard = this.creatives[displayIndex];
		} else {
			this.semCreativeCard = {};
		}
	}

	nextArrow() {
		if (this.creatives.length > 1) {
			if (0 === this.displayIndex) {
				this.displayIndex = this.creatives.length - 1;
				this.setDisplayIndexContent(this.displayIndex);
			} else {
				this.displayIndex = this.displayIndex - 1;
				this.setDisplayIndexContent(this.displayIndex);
			}
		}
		if (this.count === 1) {
			this.count = this.creatives.length;
		} else {
			this.count = this.count - 1;
		}
	}

	prevArrow() {
		if (this.creatives.length > 1) {
			if (this.creatives.length - 1 === this.displayIndex) {
				this.displayIndex = 0;
				this.setDisplayIndexContent(this.displayIndex);
			} else {
				this.displayIndex = this.displayIndex + 1;
				this.setDisplayIndexContent(this.displayIndex);
			}
		}
		if (this.creatives.length === this.count) {
			this.count = 1;
		} else {
			this.count = this.count + 1;
		}
	}

	downloadCSV() {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}
}
